// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3Lkbb","label":"Labeled_label__3ojo9","divider":"Labeled_divider__3NZXF"};